import type { UsersAndContacts } from '@/types/contacts'
import { getConsistentGradientBackground } from '@/utils/avatarUtils'

// Mock data for testing contacts functionality - matching React Native app design
export const mockContacts: UsersAndContacts[] = [
  // Pinned contacts (favorites)
  {
    id: '1',
    username: undefined,
    first_name: 'Alice',
    last_name: '',
    phone_number: '+1234567890',
    avatar_path: undefined,
    avatarBg: getConsistentGradientBackground('Alice'),
    is_blocked: false,
    is_favorite: true,
  },
  {
    id: '3',
    username: undefined,
    first_name: 'Charlie',
    last_name: '',
    phone_number: '+1234567892',
    avatar_path: undefined,
    avatarBg: getConsistentGradientBackground('Charlie'),
    is_blocked: false,
    is_favorite: true,
  },
  {
    id: '6',
    username: undefined,
    first_name: 'Frank',
    last_name: '',
    phone_number: '+1234567895',
    avatar_path: undefined,
    avatarBg: getConsistentGradientBackground('Frank'),
    is_blocked: false,
    is_favorite: true,
  },

  // Regular contacts
  {
    id: '9',
    username: 'ivanspiridonov',
    first_name: 'Ivan',
    last_name: '',
    phone_number: '+1234567899',
    avatar_path: undefined,
    avatarBg: ['#FF6B6B', '#FF8E53'], // Red gradient like in screenshot
    is_blocked: false,
    is_favorite: false,
  },
  {
    id: '10',
    username: 'gregchich',
    first_name: 'George',
    last_name: '',
    phone_number: '+1234567900',
    avatar_path: undefined,
    avatarBg: getConsistentGradientBackground('George'),
    is_blocked: false,
    is_favorite: false,
  },
  {
    id: '11',
    username: 'zxcnebuster',
    first_name: 'Yosef',
    last_name: '',
    phone_number: '+1234567901',
    avatar_path: undefined,
    avatarBg: getConsistentGradientBackground('Yosef'),
    is_blocked: false,
    is_favorite: false,
  },
  {
    id: '2',
    username: 'bob_trader',
    first_name: 'Bob',
    last_name: 'Smith',
    phone_number: '+1234567891',
    avatar_path: undefined,
    avatarBg: getConsistentGradientBackground('bob_trader'),
    is_blocked: false,
    is_favorite: false,
  },
  {
    id: '4',
    username: 'diana_eth',
    first_name: 'Diana',
    last_name: 'Wilson',
    phone_number: '+1234567893',
    avatar_path: undefined,
    avatarBg: getConsistentGradientBackground('diana_eth'),
    is_blocked: false,
    is_favorite: false,
  },
  {
    id: '5',
    username: 'eve_defi',
    first_name: 'Eve',
    last_name: 'Davis',
    phone_number: '+1234567894',
    avatar_path: undefined,
    avatarBg: getConsistentGradientBackground('eve_defi'),
    is_blocked: false,
    is_favorite: false,
  },
  {
    id: '7',
    username: 'grace_web3',
    first_name: 'Grace',
    last_name: 'Chen',
    phone_number: '+1234567896',
    avatar_path: undefined,
    avatarBg: getConsistentGradientBackground('grace_web3'),
    is_blocked: false,
    is_favorite: false,
  },
  {
    id: '8',
    username: 'henry_dao',
    first_name: 'Henry',
    last_name: 'Lee',
    phone_number: '+1234567897',
    avatar_path: undefined,
    avatarBg: getConsistentGradientBackground('henry_dao'),
    is_blocked: false,
    is_favorite: false,
  },
]

// Mock search function for testing
export const mockSearchContacts = (query: string): UsersAndContacts[] => {
  if (!query) {
    return []
  }

  // In development, allow search with any length for testing
  const normalizedQuery = query.toLowerCase()

  return mockContacts.filter(
    (contact) =>
      contact.first_name.toLowerCase().includes(normalizedQuery) ||
      contact.last_name.toLowerCase().includes(normalizedQuery) ||
      (contact.username &&
        contact.username.toLowerCase().includes(normalizedQuery)) ||
      (contact.phone_number && contact.phone_number.includes(query)),
  )
}

// Mock favorites
export const mockFavoriteContacts = mockContacts.filter(
  (contact) => contact.is_favorite,
)
